import { render, staticRenderFns } from "./GiftSetsAlertDashboard.vue?vue&type=template&id=0b325629"
import script from "./GiftSetsAlertDashboard.vue?vue&type=script&lang=js"
export * from "./GiftSetsAlertDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports